import { useQuery } from "@tanstack/react-query";
import { AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { endpoints } from "@/api/client";
import { Button } from "@/components/ui/button";

/** Avviso non bloccante: CER usati in elenco, movimenti e FIR oltre gli slot pagati. */
export function CerQuotaBanner() {
  const navigate = useNavigate();
  const quotaQ = useQuery({
    queryKey: ["billing-cer-quota"],
    queryFn: endpoints.billing.cerQuota,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });

  const q = quotaQ.data;
  if (!q || !q.subscription_active || q.cer_over_quota <= 0) return null;

  const packs = q.packs_needed;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-amber-500/40 bg-amber-500/15 px-4 py-2 text-sm">
      <span className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" />
        <span>
          Hai CER aggiuntivi da pagare: stai usando <strong>{q.cer_used_effective}</strong> CER, il
          piano ne copre <strong>{q.cer_slots}</strong>. Acquista {packs}{" "}
          {packs === 1 ? "pacchetto" : "pacchetti"} da {q.cer_pack_slots} CER (€20 + IVA all&apos;anno
          ciascuno).
        </span>
      </span>
      <Button size="sm" variant="outline" onClick={() => navigate("/cer-attivi")}>
        Acquista CER
      </Button>
    </div>
  );
}
